/* Galerie & Kunsthaus Nottbohm — Warenkorb: Abholung oder Lieferung
   Für Werke gibt es im Checkout nur die Abholung in der Galerie. Wer eine
   Lieferung möchte, setzt im Warenkorb (Fenster und Warenkorbseite) ein Häkchen.
   Das wird als Warenkorb-Attribut „Lieferung angefragt: Ja“ gespeichert
   und steht später in der Bestellung unter „Zusätzliche Details“.
   Ausnahme: Liegen nur versandfähige Artikel im Warenkorb, steht statt des
   Häkchens der Hinweis auf den Versand.
   Versandfähig heißt hier: Der Artikel hat ein Gewicht hinterlegt (grams > 0).
   Das ist bewusst keine Liste von Produktnamen — jedes Produkt, das wirklich
   verschickt wird, bekommt ein Gewicht und damit automatisch den richtigen
   Kasten. Werke ohne Gewicht bleiben beim Anfrage-Häkchen.
   Zugehörige Versandprofile: „Gänseliesel – 9,90 € je 3 Figuren“ und
   „Michael Ferner – 9,90 € je 3 Drucke“, beide 9,90 € je angefangene drei Stück.
   Außerdem werden die Express-Buttons (u. a. Shop Pay) im Warenkorb ausgeblendet.
   Nicht Teil des Impression-Themes.
*/
(function () {
	"use strict";

	var ATTRIBUT = "Lieferung angefragt";
	var ZIELE = [".cart-drawer__summary", ".cart-footer__main"];
	var angefragt = false;
	var nurVersandfaehig = false;

	function stil() {
		if (document.getElementById("nb-lieferung-stil")) return;
		var s = document.createElement("style");
		s.id = "nb-lieferung-stil";
		s.textContent =
			".nb-lieferung{margin:0 0 20px;padding:16px 18px;border:1px solid #e2e6ea;border-radius:2px;background:#fff;text-align:left}" +
			".nb-lieferung__titel{margin:0 0 6px;font-size:15px;color:#1d336f}" +
			".nb-lieferung__text{margin:0 0 12px;font-size:13px;line-height:1.5;color:#67696e}" +
			".nb-lieferung--versand .nb-lieferung__text{margin:0}" +
			".nb-lieferung__zeile{display:flex;align-items:flex-start;gap:10px;cursor:pointer;font-size:14px;color:#2b2b2b}" +
			".nb-lieferung__zeile input{width:18px;height:18px;margin:2px 0 0;flex:0 0 auto;accent-color:#1d336f;cursor:pointer}" +
			".nb-lieferung__hinweis{display:none;margin:10px 0 0;font-size:13px;line-height:1.5;color:#1d336f}" +
			".nb-lieferung.is-angefragt .nb-lieferung__hinweis{display:block}" +
			/* Express-Buttons (Shop Pay, PayPal, Google Pay) im Warenkorb ausblenden.
			   Shop Pay allein lässt sich nicht sauber entfernen – Shopify hält den
			   Platz frei. PayPal bleibt im Checkout als Zahlungsart verfügbar. */
			".cart-drawer__footer-ctas-additional,.cart-footer__ctas--additional{display:none!important}";
		document.head.appendChild(s);
	}

	function kasten(nr) {
		var box = document.createElement("div");
		if (nurVersandfaehig) {
			box.className = "nb-lieferung nb-lieferung--versand";
			box.setAttribute("data-modus", "versand");
			box.innerHTML =
				'<p class="nb-lieferung__titel">Versand oder Abholung</p>' +
				'<p class="nb-lieferung__text">Wir versenden innerhalb Deutschlands für 9,90 € je Paket – in ein Paket passen bis zu drei Stück. ' +
				"Im nächsten Schritt wählst du zwischen Versand und der kostenfreien Abholung in unserer Galerie " +
				"in der Kurzen Geismarstraße 31 in Göttingen.</p>";
			return box;
		}
		box.className = "nb-lieferung" + (angefragt ? " is-angefragt" : "");
		box.setAttribute("data-modus", "anfrage");
		box.innerHTML =
			'<p class="nb-lieferung__titel">Abholung oder Lieferung</p>' +
			'<p class="nb-lieferung__text">Dein Werk holst du kostenfrei in unserer Galerie in der Kurzen Geismarstraße 31 in Göttingen ab. ' +
			'Eine Lieferung kalkulieren wir für jedes Werk einzeln.</p>' +
			'<label class="nb-lieferung__zeile" for="nb-lieferung-' + nr + '">' +
				'<input type="checkbox" id="nb-lieferung-' + nr + '" class="js-nb-lieferung"' + (angefragt ? " checked" : "") + ">" +
				"<span>Lieferung anfragen – wir melden uns nach deiner Bestellung mit einem Angebot</span>" +
			"</label>" +
			'<p class="nb-lieferung__hinweis">Im nächsten Schritt ist die Abholung vorausgewählt. Das passt so – die Lieferung stimmen wir anschließend persönlich mit dir ab.</p>';
		return box;
	}

	function einsetzen() {
		stil();
		var nr = 0;
		var modus = nurVersandfaehig ? "versand" : "anfrage";
		ZIELE.forEach(function (auswahl) {
			Array.prototype.forEach.call(document.querySelectorAll(auswahl), function (ziel) {
				nr++;
				var vorhanden = ziel.querySelector(":scope > .nb-lieferung");
				if (vorhanden && vorhanden.getAttribute("data-modus") !== modus) {
					vorhanden.parentNode.removeChild(vorhanden);
					vorhanden = null;
				}
				if (vorhanden) {
					var h = vorhanden.querySelector(".js-nb-lieferung");
					if (h && h.checked !== angefragt) h.checked = angefragt;
					vorhanden.classList.toggle("is-angefragt", angefragt && modus === "anfrage");
					return;
				}
				ziel.insertBefore(kasten(nr), ziel.firstChild);
			});
		});
	}

	function speichern(wert) {
		var attribute = {};
		attribute[ATTRIBUT] = wert ? "Ja" : "";
		return fetch("/cart/update.js", {
			method: "POST",
			headers: { "Content-Type": "application/json", "Accept": "application/json" },
			body: JSON.stringify({ attributes: attribute })
		});
	}

	document.addEventListener("change", function (e) {
		var h = e.target;
		if (!h || !h.classList || !h.classList.contains("js-nb-lieferung")) return;
		angefragt = h.checked;
		einsetzen();
		speichern(angefragt).catch(function () {});
	});

	function auswerten(w) {
		angefragt = !!(w && w.attributes && w.attributes[ATTRIBUT] === "Ja");
		var posten = (w && w.items) || [];
		nurVersandfaehig = posten.length > 0 && posten.every(function (p) {
			return (p.grams || 0) > 0;
		});
	}

	function laden() {
		fetch("/cart.js", { headers: { "Accept": "application/json" } })
			.then(function (r) { return r.json(); })
			.then(function (w) {
				auswerten(w);
				einsetzen();
			})
			.catch(function () { einsetzen(); });
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", laden);
	} else {
		laden();
	}

	/* Änderungen am Warenkorb (Theme-Ereignisse) */
	function lauschen() {
		var bus = window.themeCore && window.themeCore.EventBus;
		if (!bus || !bus.listen) return false;
		bus.listen("cart:updated", laden);
		bus.listen("cart:refresh", laden);
		return true;
	}
	if (!lauschen()) window.addEventListener("load", lauschen);

	if (window.MutationObserver) {
		var wartet = false;
		new MutationObserver(function () {
			if (wartet) return;
			wartet = true;
			window.setTimeout(function () { wartet = false; einsetzen(); }, 250);
		}).observe(document.body, { childList: true, subtree: true });
	}
})();